var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DimLayer',{attrs:{"isOpen":_vm.isOpen},on:{"click:bgDim":_vm.onClickBgDim}}),_c('router-view',{key:_vm.$route.fullPath,attrs:{"isOpen":_vm.isOpen},on:{"click:bgDim":_vm.onClickBgDim,"click:login":_vm.onClickLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }